import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { GlobalSearchService } from 'src/app/librarys/serves/public/global-search.service';
declare var $: any;

@Component({
  selector: 'sw-global-search',
  templateUrl: './sw-global-search.component.html',
  styleUrls: ['./sw-global-search.component.css']
})
export class SwGlobalSearchComponent implements OnInit { 
  /**
   * datas 为全局搜索导航栏 
   *  datas: any = [
   * { clusterName: '', text: '全部' },
   * { clusterName: 'cms', searchMap: { "type": "archives" }, text: '资讯' }]
   */
  @Input() datas:any = []
  @Input() searchType:string = '1' //全文检索的样式类型
    /**
   * type 为全局搜索主页面布局类型
   * type为1：条件布局在查询输入框上
   * type为2：条件以下拉框的形式在搜索输入框前面
   * type为3：检索输入框聚焦点时，条件出现
   */
  @Input() type:number= 1
  active: number = 0;
  searchData: any = {}; //检索的对象
  searchList: any = [];//检索返回的对象
  pageBase: any = {
    current: 1,
    size: 10
  };
  //demo searchList2  文字较少的
  searchList2:any = [] //测试类型2
  searchList3:any = [] //测试类型3
  dropDownText: string =''; //样式2时 选择下拉框获取的对应text值
  isDisplaySearch: boolean = false; //样式3时  是否显示带有条件的搜索样式 默认不显示
  constructor(
    private router: Router,
    private activedRouter: ActivatedRoute,
    private GlobalSearchService: GlobalSearchService
  ) {
    this.activedRouter.queryParams.subscribe((param) => {
      let data
      if(param['data']){
        this.isDisplaySearch = true; //样式3 是否显示带有条件的搜索框
        data = JSON.parse(param['data']) //数据处理
        this.active = data['active'] //获取当前数据下标
        this.type = data['type'] //获取当前全文检索样式类型
        this.searchData.searchValue = data['searchValue'] //获取输入框值
        this.datas[this.active] = data['data'] //对当前对应下标的数组赋值
        if(this.type == 2){
          //检索类型2时 对下拉框text赋值
          this.dropDownText = data['data'].text
        }else if(this.type == 3){
          //检索类型3时 显示带有条件的搜索框
           this.isDisplaySearch = true;
        }
        //搜索
        this.toFullTextSearch()
      }
   })
   }

  ngOnInit() {
    //样式2 下拉框text的初始值
    if(this.type == 2){
      this.dropDownText = this.datas[this.active].text
    }
   
  }
  //样式3 聚焦搜索框时 出现带条件的样式
  onDisplay() {
    this.isDisplaySearch = true
  }
   //样式3 取消搜索框时 关闭带条件的样式
   closeDisplay() {
    this.isDisplaySearch = false
    this.active = 0; //点击取消 下标为初始值
    this.searchData.searchValue = '' //点击取消 输入数据清空
    this.searchAll(0); //点击取消后 查询
  }
    //点击下拉框 获取对应数据 样式2
    clickSearch(item,i) { 
      this.dropDownText = item.text
      this.active = i;
      this.searchAll(i)
    }
  /**
   * 点击导航栏，根据导航栏和输入的关键字，搜索对应的数据
   * @ignore
   */
  searchAll(index: number) {
   this.active = index;
   this.pageBase.current = 1;
   this.pageBase.size = 10;
   this.toFullTextSearch()
  }
  /**
   * 根据导航栏和输入的关键字，搜索对应的数据
   * @ignore
   */
  toFullTextSearch() {
    this.searchData.pageNum = this.pageBase.current;
    this.searchData.pageSize = this.pageBase.size;
    this.searchData.clusterName = this.datas[this.active].clusterName;
    this.searchData.searchMap = this.datas[this.active].searchMap;
    this.GlobalSearchService.globalSearch(this.searchData).subscribe(
      data => {
        if (data.code == 200) {
          this.searchList = data["data"]["records"];
          this.pageBase = data["data"];
        }
      }
    )
    // //假数据
    // this.searchList2 = [
    //   {
    //   flag: "活动",
    //   id: "a844872a-1204-465f-87f8-d157d2be7d51",
    //   img: "SUZHOU_BWG/活动讲座管理图片/20180903165824Ohxr65.jpg",
    //   linkUrl: "http://www.baidu.com/link?url=Ab0iKc_ojCPXh8PPI6OyXXT7dZR9bzHICCse7HNk5k8JkAsfVwLfLtI3UD3OCQD8",
    //   publish: true,
    //   route: "/hth/PortalActivityView?Title=查看活动信息&id=a844872a-1204-465f-87f8-d157d2be7d51",
    //   search1: "测试样式类型2<span>活动</span>",
    //   search2: "我是一行数据",
    //   search3: "zhengzhou/TVS/TVS_VILLAGE_IMG/20191106/19a51c0871364adabf3ff24920ab08db1573017343166.jpg",
    //   search4: "SUZHOU_BWG/活动讲座管理图片/20150623104053lEwHky.jpg",
    //   search5: "SUZHOU_BWG/活动讲座管理图片/web_fae96162-c5ee-4b5e-98ce-430d0ca6934c.jpg",
    //   type: "activity",
    //   updateTime: "2018-09-03T16:00:00.000Z"}
    // ]
    // //假数据
    // this.searchList3 = [
    //   {
    //   flag: "活动",
    //   id: "a844872a-1204-465f-87f8-d157d2be7d52",
    //   img: "SUZHOU_BWG/活动讲座管理图片/20180903165824Ohxr65.jpg",
    //   linkUrl: "http://www.baidu.com/link?url=Ab0iKc_ojCPXh8PPI6OyXXT7dZR9bzHICCse7HNk5k8JkAsfVwLfLtI3UD3OCQD8",
    //   publish: true,
    //   route: "/hth/PortalActivityView?Title=查看活动信息&id=a844872a-1204-465f-87f8-d157d2be7d51",
    //   search1: "测试样式类型3<span>活动</span>",
    //   search2: "SUZHOU_BWG/活动讲座管理图片/web_ba7a41b1-32e5-4fcb-bad5-43369c0307c9.jpg",
    //   search3: "SUZHOU_BWG/活动讲座管理图片/20161027090946ErKsBf.jpg",
    //   search4: "SUZHOU_BWG/活动讲座管理图片/201801261820492sKJJh.jpg",
    //   search5: "SUZHOU_BWG/活动讲座管理图片/201612220951191f7sN7.jpg",
    //   type: "activity",
    //   updateTime: "2018-09-03T16:00:00.000Z"}
    // ]
  }
  /**
   * 分页
   * @ignore
   */
  clickPageQuery(event) {
    this.pageBase = event;
    this.toFullTextSearch();
  }
  /**
   * 初始图片
   * @ignore
   */
   initImg(item){
    let path: string = environment.staticFileUrl;
    if(item['img']){
      return path+item['img']
    }
    return ''
   }
  //根据图片路径 初始化图片
  initImgUrl(url){
    let path: string = environment.staticFileUrl;
    if(url){
      return path+url
    }
    return ''
  }
  /**
   * 根据参数，打开新路由
   * @ignore
   */  
  toOpenView(data) {
    if(data['route']){
      let route = data['route']
      let url = route.split('?')[0]; //获取跳转路径
      let param = route.split('?')[1]; //获取参数
      if(param){
       let params = this.getUrlVars(param)
       let queryParams = {
        queryParams:params
       }
       this.router.navigate([url], queryParams);
     }else {
       this.router.navigate([url]);
     }
    }
  }
  /**
   * 处理url参数，转为json对象
   * 如 'Title=内容查看&Operate=view&languageType=CN&groupId=dfb28e30a08b4cd39a7ee57b5993c5c2'
   * @ignore
   */
  getUrlVars(url) {
    var hash;
    var myJson = {};
    var hashes = url.slice(url.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        myJson[hash[0]] = hash[1];
    }
    return myJson;
  }
  /**
   * 键盘enter键 全局搜索
   */
  enterSelect(event) {
    if(event.keyCode == 13) {
       this.toFullTextSearch()
    }
  }
  /**
   * 打开超链接
   */
  openLinkUrl(linkUrl) {
    window.open(linkUrl)
  }
}
